import type { IWorkspace } from '@platform/core/types';
import { memberWorkspaces } from './memberWorkspaces';

/**
 * Простір входу (ADR-028), коли поточного простору вкладки немає (вхід, реєстрація, спостерігач, нова вкладка без останнього) чи він
 * більше не доступний: власний офіс депутата (тип mp, роль Owner), інакше перший простір, де користувач учасник; без просторів —
 * undefined (тоді «Створити робочий простір»). Чиста функція.
 */
export function landingWorkspace(workspaces: readonly IWorkspace[]): string | undefined {
  const member = memberWorkspaces(workspaces);
  return (member.find((w) => w.type === 'mp' && w.myRole === 'Owner') ?? member[0])?.id;
}
